/**
 * Organization role flags from subscriptions/all (stored in userReducer on login).
 *
 * API fields:
 * - IsEnterprisePowerUser / IsPowerUser: EnterpriseCustomers.Admin for this user
 * - CanUpdateOrganizationAiCredits: may edit monthly AI credit allowance
 * - IsOrganizationPowerUser: org owner / enterprise admin / platform admin
 * - EnterprisePowerUserFirebaseId: org subscription owner's Firebase id
 */
export function isEnterprisePowerUser(session) {
  if (!session) return false;
  return Boolean(session.IsEnterprisePowerUser ?? session.IsPowerUser);
}

export function canUpdateOrganizationAiCredits(session) {
  if (!session) return false;
  if (session.CanUpdateOrganizationAiCredits != null) {
    return Boolean(session.CanUpdateOrganizationAiCredits);
  }
  return isEnterprisePowerUser(session);
}

export function isOrganizationPowerUser(session) {
  return Boolean(session?.IsOrganizationPowerUser);
}

export function getEnterprisePowerUserFirebaseId(session) {
  return session?.EnterprisePowerUserFirebaseId || null;
}

/** subscriptions/all may return a bare array or a single subscription object. */
export function normalizeSubscriptionAllResponse(result) {
  if (!result || result.error) return null;
  if (Array.isArray(result)) return result[0] ?? null;
  if (Array.isArray(result?.data)) return result.data[0] ?? null;
  if (
    result.PackageId != null ||
    result.IsEnterprisePowerUser != null ||
    result.IsPowerUser != null
  ) {
    return result;
  }
  return result[0] ?? null;
}
